export enum enumCreationNoInTEN {
  'ONE' = 1,
  'TWO'
}

export namespace enumCreationNoInTEN {
  export function values() {
    return Object.keys(enumCreationNoInTEN).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
